import React, { forwardRef } from 'react';
import Select, { createFilter } from 'react-select';
import { TwoColumnOption, TwoColumnValueContainer } from './TwoColumnList';
import { useCustomStyles } from './dropDown.styles';
const DropDown = forwardRef(({ allowAll, allOption, deselectable, menuType, loading, className, disabled, value: valueProp = [], options: optionsProp = [], onChange, onMenuClose, menuPlacement = 'bottom', defaultMenuIsOpen, menuIsOpen, placeholder, ...rest }, ref) => {
    const customStyles = useCustomStyles();
    const options = [...optionsProp];
    if (allowAll)
        options.unshift(allOption);
    if (deselectable)
        options.unshift({
            label: `--- ${placeholder?.toLowerCase()} ---`,
            value: 'deselect',
        });
    let value = valueProp;
    if (allowAll && Array.isArray(valueProp)) {
        value = [allOption];
    }
    const handleChange = (selected) => {
        if (Array.isArray(selected) && allowAll) {
            const arrayContainsAll = selected.find(option => option.value === allOption?.value);
            // @ts-ignore
            if (arrayContainsAll)
                return onChange([allOption]);
        }
        if (deselectable && selected?.value === 'deselect')
            return onChange(undefined);
        return onChange(selected);
    };
    const customComponents = () => {
        if (menuType === 'twoColumnMenu')
            return {
                Option: TwoColumnOption,
                ValueContainer: TwoColumnValueContainer,
            };
        return undefined;
    };
    return (React.createElement(Select, { ref: ref, ...rest, placeholder: placeholder, onMenuClose: onMenuClose, menuPlacement: menuPlacement, menuIsOpen: menuIsOpen, defaultMenuIsOpen: defaultMenuIsOpen, isLoading: loading, isDisabled: disabled, menuPortalTarget: document.body, styles: customStyles, className: className, classNamePrefix: "dropDown", onChange: selected => handleChange(selected), options: options, value: value, components: customComponents(), 
        /**
         * Reduces lag when searching through a long list of options
         * See: https://github.com/JedWatson/react-select/issues/3128
         */
        filterOption: createFilter({ ignoreAccents: false }), "data-test": "select" }));
});
export default DropDown;
//# sourceMappingURL=DropDown.js.map